export default __webpack_public_path__ + "static/media/login.d59d5872.svg";